/**
 * Order Delivery Log sources describing what source triggers logging.
 */
export enum OrderDeliveryLogSourceEnum {
  UPCO = 'UPCO',
  GIGABLE = 'GIGABLE_DELIVERY_PROVIDER',
  ONDWAY = 'ONDWAY_DELIVERY_PROVIDER',
  UNKNOWN = "UNKNOWN"
}
